// @flow

import Game from '@/lib/game';
import {
  CherryForest,
  CedarForest,
  BeechForest,
  CreForest,
  MapleForest,
  ZelkovaForest,
} from '@/lib/achievement_conditions';

declare type Achievement = {
  uid: string,
  title: string,
  body: string,
};

export default class {
  game: Game;
  achievements: Achievement[];
  conditions: { isSatisfied(any): boolean, makeAchievement(): Achievement }[];

  constructor(game: Game) {
    this.game = game;
    this.achievements = [];
    this.conditions = [
      CherryForest,
      CedarForest,
      BeechForest,
      CreForest,
      MapleForest,
      ZelkovaForest,
    ];
  }

  process() {
    // 条件を満たしていれば次回評価対象から削除
    this.conditions = this.conditions.filter(condition => {
      if (condition.isSatisfied(this.game)) {
        this.achievements.push(condition.makeAchievement());
        return false;
      }

      return true;
    });
  }
}



// WEBPACK FOOTER //
// ./src/lib/achievement_manager/achievement_manager.js